/* Copyright (c) 2017 Backpack Health LLC */

const tokenDurations = {
  LONG: 'long',
  SHORT: 'short',
};

export default tokenDurations;
